module.exports = __webpack_public_path__ + "static/media/pending-orange-loader.2d564bc4.svg";